import { render, staticRenderFns } from "./MypageMailChangeCompletePane.vue?vue&type=template&id=42e3a95e&scoped=true"
import script from "./MypageMailChangeCompletePane.vue?vue&type=script&lang=ts"
export * from "./MypageMailChangeCompletePane.vue?vue&type=script&lang=ts"
import style0 from "./MypageMailChangeCompletePane.vue?vue&type=style&index=0&id=42e3a95e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e3a95e",
  null
  
)

export default component.exports